export const DX7 = `
dx7_1=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5 + op6 * m5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1 + op2 * m1)
  op1
}

dx7_2=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5 + op6 * m5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1)
  op1 + op2
}

dx7_3=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5 + op6 * m5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3)
  op2 = sin(hz:hz * r2 + op4 * m2)
  op1 = sin(hz:hz * r1)
  op1 + op2 + op3
}

dx7_4=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5 + op6 * m5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3 + op5 * m3)
  op2 = sin(hz:hz * r2 + op4 * m2)
  op1 = sin(hz:hz * r1)
  op1 + op2 + op3
}

dx7_5=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3)
  op2 = sin(hz:hz * r2 + op4 * m2)
  op1 = sin(hz:hz * r1 + op3 * m1)
  op1 + op2 + op6
}

dx7_6=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5 + op6 * m5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2)
  op1 = sin(hz:hz * r1)
  op1 + op2 + op3
}

dx7_7=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5 + op6 * m5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3 + op5 * m3)
  op2 = sin(hz:hz * r2)
  op1 = sin(hz:hz * r1 + op3 * m1)
  op1 + op2
}

dx7_8=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2)
  op1 = sin(hz:hz * r1)
  op1 + op2 + op3 + op6
}

dx7_9=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5 + op6 * m5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3)
  op2 = sin(hz:hz * r2)
  op1 = sin(hz:hz * r1 + op4 * m1)
  op1 + op2 + op3
}

dx7_10=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5 + op6 * m5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2)
  op1 = sin(hz:hz * r1 + op2 * m1)
  op1 + op3
}

dx7_11=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5 + op6 * m5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1 + op2 * m1)
  op1 + op4 + op5
}

dx7_12=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1)
  op1 + op2 + op6
}

dx7_13=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3)
  op2 = sin(hz:hz * r2 + op4 * m2)
  op1 = sin(hz:hz * r1)
  op1 + op2 + op3 + op6
}

dx7_14=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1 + op2 * m1)
  op1
}

dx7_15=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2)
  op1 = sin(hz:hz * r1 + op3 * m1)
  op1 + op2
}

dx7_16=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1 + op2 * m1)
  op1
}

dx7_17=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5 + op6 * m5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2)
  op1 = sin(hz:hz * r1)
  op1 + op2 + op3
}

dx7_18=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5 + op6 * m5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1)
  op1 + op2
}

dx7_19=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2)
  op1 = sin(hz:hz * r1 + op6 * m1)
  op1 + op2 + op3
}

dx7_20=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2)
  op1 = sin(hz:hz * r1 + op3 * m1)
  op1 + op2 + op5
}

dx7_21=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2)
  op1 = sin(hz:hz * r1)
  op1 + op2 + op3 + op6
}

dx7_22=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1 + op2 * m1)
  op1 + op4
}

dx7_23=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5 + op6 * m5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2)
  op1 = sin(hz:hz * r1 + op3 * m1)
  op1 + op2 + op5
}

dx7_24=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3)
  op2 = sin(hz:hz * r2 + op4 * m2)
  op1 = sin(hz:hz * r1 + op2 * m1)
  op1 + op3 + op6
}

dx7_25=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1 + op2 * m1)
  op1 + op5 + op6
}

dx7_26=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1 + op2 * m1)
  op1
}

dx7_27=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1)
  op1 + op2 + op5
}

dx7_28=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5 + op6 * m5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1 + op2 * m1)
  op1 + op4 + op5
}

dx7_29=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4 + op5 * m4)
  op3 = sin(hz:hz * r3 + op4 * m3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1 + op2 * m1)
  op1 + op6
}

dx7_30=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3)
  op2 = sin(hz:hz * r2 + op3 * m2)
  op1 = sin(hz:hz * r1 + op2 * m1)
  op1 + op4 + op5 + op6
}

dx7_31=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3)
  op2 = sin(hz:hz * r2)
  op1 = sin(hz:hz * r1)
  op1 + op2 + op3 + op4 + op5 + op6
}

dx7_32=(hz,r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,m1=1,m2=1,m3=1,m4=1,m5=1)->{
  op6 = sin(hz:hz * r6)
  op5 = sin(hz:hz * r5)
  op4 = sin(hz:hz * r4)
  op3 = sin(hz:hz * r3)
  op2 = sin(hz:hz * r2)
  op1 = sin(hz:hz * r1)
  op1 + op2 + op3 + op4 + op5 + op6
}
`
